mutation CreateTargetAudience($targetAudienceInput: TargetAudienceInput!) {
  createTargetAudience(input: { targetAudienceInput: $targetAudienceInput }) {
    targetAudience {
      id
    }
  }
}
